import { UnmappedDatapoints } from '@/mapping/UnmappedDatapoints';
import { UnmappedQuestionTypes } from '@/mapping/UnmappedQuestionTypes';
import { Export, Survey } from '@/surveys/dataContracts';
import { Client } from '@holistic/shared/src/domain/Client';
import { BaseSurveyTemplate } from '@holistic/shared/src/domain/surveyTemplates/SurveyTemplate';
import { Widget } from '@holistic/shared/src/domain/widgets/Widget';
import { WidgetImportErrorHolder } from '@holistic/shared/src/domain/widgets/WidgetImportErrorHolder';

export interface VuexSurveyTemplate extends BaseSurveyTemplate {
  id: string;
}

export interface State {
  clients: Client[];
  clientReport: [Widget] | [] | null;
  defaultExport: Export | null;
  reports: Widget[];
  reportErrors: WidgetImportErrorHolder[];
  survey: Survey | null;
  surveyTemplates: VuexSurveyTemplate[];
  unmappedDatapoints: UnmappedDatapoints | null;
  unmappedQuestionTypes: UnmappedQuestionTypes | null;
}

export const createDefaultState = (): State => ({
  clients: [],
  clientReport: null,
  defaultExport: null,
  reports: [],
  reportErrors: [],
  survey: null,
  surveyTemplates: [],
  unmappedDatapoints: null,
  unmappedQuestionTypes: null,
});
